import type { SystemPropertyUpdate } from '../systemEditSchema'

export function handleTimezoneOffset(system: any, operation: SystemPropertyUpdate): void {
  let timezoneOffsetValue: number

  // Convert value to number
  if (typeof operation.value === 'number') {
    timezoneOffsetValue = operation.value
  } else if (typeof operation.value === 'string') {
    timezoneOffsetValue = parseFloat(operation.value)
    if (isNaN(timezoneOffsetValue)) {
      throw new Error(`Invalid timezoneOffset value: ${operation.value}. Must be a number.`)
    }
  } else if (operation.value === null || operation.value === undefined) {
    // Default to 0 if null/undefined
    timezoneOffsetValue = 0
  } else {
    throw new Error(`Invalid timezoneOffset value: ${operation.value}. Must be a number.`)
  }

  // Set timezoneOffset on the scene (not the system)
  window.editor.execute(new window.SetValueCommand(window.editor.scene, 'timezoneOffset', timezoneOffsetValue))

  // Call manually because changes to scene do not automatically trigger clearing shading and recalc
  if (window.SceneHelper) {
    window.SceneHelper.clearShadingAndRecalc()
  }
}
